import React from 'react';
import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';
import clsx from '@strava/ui/clsx';
import { Markup } from 'interweave';

import Discounts from './Discounts';
import { useCheckoutContext } from '../../../state/CheckoutContext';
import { I18nPrefixOrganic } from '../../../shared/constants';

import styles from './PricingList.scss';

const renderPerMonthPrice = (price, currency) => (
  <Markup
    tagName="span"
    content={I18n.t(`${I18nPrefixOrganic}.per_month`, {
      class: 'price',
      price: Cldr.formatCurrency(price, currency)
    })}
  />
);

const renderPerYearPrice = (price, currency) => (
  <Markup
    tagName="span"
    content={I18n.t(`${I18nPrefixOrganic}.per_year`, {
      class: 'price',
      price: Cldr.formatCurrency(price, currency)
    })}
  />
);

export const PricingList = () => {
  const { checkoutEntityState } = useCheckoutContext();

  const {
    products,
    pricing
  } = checkoutEntityState;
  const {
    yearlyTotal,
    monthlyTotal,
    billedToday: totalPrimaryPrice,
    currency,
    discounts,
    duration
  } = pricing;
  const promotionDuration = products?.promotion?.argument;
  const isYearlyDuration = duration === 'yearly';
  const hasDiscounts = discounts && discounts.length > 0;

  const totalPrimaryText = isYearlyDuration
    ? renderPerYearPrice(totalPrimaryPrice, currency)
    : renderPerMonthPrice(totalPrimaryPrice, currency);

  const subtotalText = isYearlyDuration
    ? renderPerYearPrice(yearlyTotal, currency)
    : renderPerMonthPrice(monthlyTotal, currency);

  const promoBilledAfterText = I18n.t(
    `${I18nPrefixOrganic}.billed_after.${duration}`,
    {
      count: promotionDuration
    }
  );

  return (
    <div className={styles.pricingList}>
      <div className={styles.totals}>
        <div>
          {I18n.t(`${I18nPrefixOrganic}.${'billed_today'}`)}
        </div>
        <div className="text-right">
          <div
            className={styles.totalPrimaryText}
            data-testid="price-list-total-primary-text"
          >
            {totalPrimaryText}
          </div>
        </div>
      </div>
      <div
        className={clsx(
          styles.priceRow,
          styles.note,
          hasDiscounts && styles.discounts
        )}
      >
        <div>
          {hasDiscounts
            ? promoBilledAfterText
            : I18n.t(`${I18nPrefixOrganic}.renews`)}
        </div>
        {hasDiscounts && <div>{subtotalText}</div>}
      </div>
      {hasDiscounts && <Discounts />}
    </div>
  );
};

export default PricingList;
